import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Mic off SVG Icon for mic control button.
 */
export const MicOff: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 35 35"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M16.9637 0.875C14.3411 0.875 12.3929 2.74403 12.0333 5.532V5.9681L22.059 16.3879C22.074 16.2789 22.089 16.1543 22.089 16.0453V6.46651C22.089 3.13341 19.871 0.875 16.9637 0.875ZM28.1584 28.7391C28.608 29.2064 29.3423 29.2064 29.7769 28.7391C30.2115 28.2718 30.2265 27.5242 29.7769 27.057L6.6982 3.10226C6.2636 2.635 5.52928 2.635 5.06471 3.10226C4.6451 3.55394 4.6451 4.3327 5.06471 4.78438L28.1584 28.7391ZM5.829 16.715C5.829 22.9451 9.83031 27.166 15.54 27.7579V30.5614H10.3548C9.54557 30.5614 8.85621 31.2467 8.85621 32.0878C8.85621 32.9288 9.54557 33.6297 10.3548 33.6297H23.5726C24.3969 33.6297 25.0712 32.9288 25.0712 32.0878C25.0712 31.2467 24.3969 30.5614 23.5726 30.5614H18.4024V27.7579C20.1708 27.5865 21.7743 27.057 23.123 26.2159L20.995 23.9731C19.8411 24.5805 18.4773 24.9232 16.9637 24.9232C12.1532 24.9232 8.81125 21.6212 8.81125 16.606V13.8492C8.81125 12.9925 8.13687 12.3384 7.31263 12.3384C6.4884 12.3384 5.829 12.9925 5.829 13.8492V16.715ZM24.7415 19.1603L27.1243 21.6368C27.7688 20.2039 28.1134 18.5529 28.1134 16.715V13.8492C28.1134 12.9925 27.4391 12.3384 26.6298 12.3384C25.8056 12.3384 25.1312 12.9925 25.1312 13.8492V16.606C25.1312 17.5405 24.9963 18.3816 24.7415 19.1603ZM16.9637 21.9171C17.5782 21.9171 18.1626 21.8081 18.6871 21.5901L11.8385 14.4722V16.3256C11.8385 19.6587 14.0714 21.9171 16.9637 21.9171Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
